/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-15 10:03:59
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-20 17:21:46
 * @name: 设置
 * @Description: 设置
 * @FilePath: \preSaleNafterSaleBackstage\src\object\setting\setting.class.js
 * @Author: desktop
 */
import { sysConfigDetail, sysConfigEdit } from "@/api/index/index.api";
import { apiMethod } from '@/utils/decorator.js';

const setting = class setting {
  constructor() {
    this.settle_day = ''; //出账日
    this.settle_limit_day = ''; //还账日
    this.account = ''; //公司账户
    this.account_name = ''; //公司户名
    this.bank = ''; //收款银行
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 查询设置配置
   */
  @apiMethod(sysConfigDetail)
  async getSysConfigDetail(res) {
    if (res.code === 200) {
      const obj = res.data;
      this.settle_day = obj?.settle_day ?? '';
      this.settle_limit_day = obj?.settle_limit_day ?? '';
      this.account = obj?.account ?? '';
      this.account_name = obj?.account_name ?? '';
      this.bank = obj?.bank ?? '';
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 提交设置配置
   */
  @apiMethod(sysConfigEdit)
  async sysConfigEdit(res) { }
}
export default setting;